import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';

import MenuItem from './MenuItem';

type Props = {
  order: string;
  societyId: string;
  isActive: boolean;
};

const DocumentsMenu: FC<Props> = ({ order, societyId, isActive }) => {
  const { t } = useTranslate();

  return (
    <>
      <Accordion.Toggle as={Button} variant="link" eventKey={order}>
        <li className={`nk-menu-item has-sub ${isActive ? 'active' : ''}`}>
          <a className="nk-menu-link nk-menu-toggle">
            <span className="nk-menu-icon">
              <em className="icon ni ni-files" />
            </span>
            <span className="nk-menu-text">{t('Documents')}</span>
          </a>
        </li>
      </Accordion.Toggle>

      <Accordion.Collapse eventKey={order}>
        <ul className="nk-menu-sub">
          <MenuItem linkTo={`/documentos/${societyId}`} text="Documents" />
        </ul>
      </Accordion.Collapse>
    </>
  );
};

export default DocumentsMenu;
